import { useToasted } from "@hoppscotch/vue-toasted"

export const useToast = useToasted
